/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconDocumentGraphLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 24 25.5">
    <><style type="text/css">{`
    .st0 {
        fill: #FFFFFF;
        stroke: #000000;
        stroke-width: 1.5;
        stroke-linecap: round;
        stroke-linejoin: round;
    }

    .st1 {
        fill: none;
        stroke: #000000;
        stroke-width: 1.5;
        stroke-linecap: round;
        stroke-linejoin: round;
    }

    .st2 {
        fill: none;
        stroke: #000000;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
    }

    .st3 {
        fill: #000;
        stroke: #000000;
        stroke-width: 0.5;
        stroke-linecap: round;
        stroke-linejoin: round;
    }

    .st4 {
        fill: none;
    }
`}</style>
<g id="Layer_1-2">
    <g>
        <g>
            <g>
                <path className="st0" d="M21.6,6.8v14.3c0,2-1.7,3.6-3.8,3.6H6.2c-2.1,0-3.8-1.6-3.8-3.6V4.4c0-2,1.7-3.7,3.8-3.7h9.2" />
                <g>
                    <line className="st1" x1="6.1" y1="7.8" x2="11" y2="7.8" />
                    <line className="st1" x1="5.9" y1="4.7" x2="8.4" y2="4.7" />
                </g>
                <polygon className="st1" points="15.3,0.8 15.3,6.8 21.6,6.8 " />
            </g>
            <g>
                <g>
                    <line className="st2" x1="15.2" y1="12.1" x2="6.1" y2="16.3" />
                    <polygon fill="#000" points="13.5,10.1 18.5,10.5 15.6,14.6 " />
                </g>
                <rect x="15.5" y="16.3" className="st3" width="3" height="5.6" />
                <rect x="10.6" y="18.2" className="st3" width="3.1" height="3.7" />
                <rect x="5.6" y="19.8" className="st3" width="3" height="2.1" />
            </g>
        </g>
        <rect y="0.8" className="st4" width="24" height="24" />
    </g>
</g></>
  </Icon>
);
};

IconDocumentGraphLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,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";
IconDocumentGraphLineComponent.Content = `<svg version="1.1" id="Layer_2_00000003806369290524611440000009951808968924094340_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 25.5" style="enable-background:new 0 0 24 25.5;" xml:space="preserve">
  <style type="text/css">
	.st0{fill:#FFFFFF;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}
	.st1{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}
	.st2{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}
	.st3{fill:#000;stroke:#000000;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;}
	.st4{fill:none;}
</style>
  <g id="Layer_1-2">
    <g>
      <g>
        <g>
          <path class="st0" d="M21.6,6.8v14.3c0,2-1.7,3.6-3.8,3.6H6.2c-2.1,0-3.8-1.6-3.8-3.6V4.4c0-2,1.7-3.7,3.8-3.7h9.2"/>
          <g>
            <line class="st1" x1="6.1" y1="7.8" x2="11" y2="7.8"/>
            <line class="st1" x1="5.9" y1="4.7" x2="8.4" y2="4.7"/>
          </g>
          <polygon class="st1" points="15.3,0.8 15.3,6.8 21.6,6.8 "/>
        </g>
        <g>
          <g>
            <line class="st2" x1="15.2" y1="12.1" x2="6.1" y2="16.3"/>
            <polygon fill="#000" points="13.5,10.1 18.5,10.5 15.6,14.6 "/>
          </g>
          <rect x="15.5" y="16.3" class="st3" width="3" height="5.6"/>
          <rect x="10.6" y="18.2" class="st3" width="3.1" height="3.7"/>
          <rect x="5.6" y="19.8" class="st3" width="3" height="2.1"/>
        </g>
      </g>
      <rect y="0.8" class="st4" width="24" height="24"/>
    </g>
  </g>
</svg>`;

const IconDocumentGraphLine = styled(IconDocumentGraphLineComponent)``;

export default IconDocumentGraphLine;
